// @flow
import * as React from 'react';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import InterlinkingBlock from '../shared/InterlinkingBlock';
import messages from '../../../messages';

type Props = {
  countryName?: string,
  links: {
    oldLocation: ?Object,
    otherJobCategories: ?Array<Object>,
    similar: ?Array<Object>,
  },
  location: Object,
};

const { citiesInRegion, otherJobCategoriesTitle, similarSearches } = messages;

function InterlinkingJobs({ countryName, location, links }: Props): React.Node {
  const { oldLocation, otherJobCategories, similar } = links;
  const interlinkingCities = oldLocation ? oldLocation.city : null;
  const interlinkingRegions = oldLocation ? oldLocation.region : null;

  const validLocation = (interlinkingCities || interlinkingRegions) && countryName;
  const validOtherJobCategories = otherJobCategories && otherJobCategories.length > 0;
  const validSimilars = similar && similar.length > 0;

  if (!validLocation && !validOtherJobCategories && !validSimilars) {
    return null;
  }

  return (
    <div id="interlinking">
      {interlinkingRegions && countryName && (
        <InterlinkingBlock
          title={<FormattedMessage values={{ '%1$s': countryName }} {...citiesInRegion} />}
          links={interlinkingRegions}
          dataTest="link-v"
        />
      )}

      {interlinkingCities && countryName && (
        <InterlinkingBlock
          title={
            <FormattedMessage values={{ '%1$s': get(location, 'region') }} {...citiesInRegion} />
          }
          links={interlinkingCities}
          dataTest="link-v"
        />
      )}

      {validOtherJobCategories && (
        <InterlinkingBlock
          title={<FormattedMessage {...otherJobCategoriesTitle} />}
          links={otherJobCategories}
          dataTest="link-sml-pro"
        />
      )}

      {validSimilars && (
        <InterlinkingBlock
          title={<FormattedMessage {...similarSearches} />}
          links={similar}
          dataTest="link-sml"
        />
      )}
    </div>
  );
}

InterlinkingJobs.defaultProps = {
  countryName: null,
};

export default InterlinkingJobs;



// WEBPACK FOOTER //
// ./app/Serp/components/Interlinking/jobs/index.js